import styled from "styled-components";
import { calcRem } from "styles/theme";

export enum TechStatusType {
  OPEN = "Open",
  PROGRESS = "In-Progress",
  CLOSE = "Closed",
}

const Container = styled.div<{ type: string }>`
  font-size: ${calcRem(14)};

  color: ${({ theme, type }) =>
    type === TechStatusType.OPEN
      ? theme.COLORS.GREEN
      : type === TechStatusType.PROGRESS
      ? theme.COLORS.BUTTONS2
      : theme.COLORS.GRAY};
`;

interface TypeProps {
  type: string;
}

function TechStatus({ type }: TypeProps): JSX.Element {
  return (
    <Container type={type} className="recorder-type">
      {type}
    </Container>
  );
}

export default TechStatus;
